import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { getTcDetailFoTrace } from "./api";
import DetailPageV3 from "./DetailPageV3";
import DetailPageV4 from "./DetailPageV4";
import { Loader } from "../assets/Icons";

const DetailPage = () => {
  const [traceVersion, setTraceVersion] = useState(null);
  const { id } = useParams();

  const getTraceDetails = async (id) => {
    try {
      const res = await getTcDetailFoTrace(id);
      const version = res?.data?.data?.__traceVersion;
      if (res?.status === true) {
        setTraceVersion(version);
      }
    } catch (error) {
      console.error("Trace fetch error:", error.message);
    }
  };

  useEffect(() => {
    if (id) getTraceDetails(id);
  }, [id]);

  if (!id || traceVersion === null) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        width="100%"
      >
        <Loader width="80px" height="80px" color="#3958DC" />
      </Box>
    );
  }

  return traceVersion === 4 ? (
    <DetailPageV4 id={id} traceVersion={traceVersion} />
  ) : (
    <DetailPageV3 id={id} traceVersion={traceVersion} />
  );
};

export default DetailPage;
